import { Grid, GridProps } from '@hover/blueprint';
import React, { FC } from 'react';
import { ICBlogPost } from '../../../interfaces/ICBlogPost';
import BlogCard from './BlogCard';

interface Props extends GridProps {
  posts: Array<ICBlogPost>;
}

const BlogCards: FC<Props> = ({ posts, ...rest }) => (
  <Grid
    templateColumns={[
      'repeat(1, 1fr)',
      'repeat(1, 1fr)',
      'repeat(2, 1fr)',
      `repeat(${3}, 1fr)`,
    ]}
    justifyContent="center"
    rowGap={10}
    columnGap={10}
    {...rest}
  >
    {posts.map(post => (
      <BlogCard post={post} key={post.slug} />
    ))}
  </Grid>
);

export default BlogCards;
